import { Controller } from "@hotwired/stimulus"

// Live preview for /ads. Reads the Creative Details inputs + the selected slot
// radio and fills the matching [data-slot] variant in _ads_slot_preview.html.erb.
// Visibility is driven entirely via inline style.display so toggles never fight
// the inline styles in the email-mirror variant.
const CONTEXT = {
  1: "On every signed-in dashboard",
  2: "Job-detail right rail",
  3: "Featured on the AI Tools page",
  4: "In the AI job-alert emails",
}

export default class extends Controller {
  static targets = ["context"]

  connect() {
    this.fields = {
      title: document.getElementById("sponsor_title"),
      subtitle: document.getElementById("sponsor_subtitle"),
      link: document.getElementById("sponsor_ads_link"),
      logoUrl: document.getElementById("sponsor_logo"),
      color: document.getElementById("sponsor_color"),
    }
    this.logoPreview = document.getElementById("logo-preview")
    this.radios = Array.from(document.querySelectorAll('input[name="sponsor[position]"]'))
    this.variants = Array.from(this.element.querySelectorAll("[data-slot]"))
    this.render = this.render.bind(this)

    Object.values(this.fields).forEach((f) => f && f.addEventListener("input", this.render))
    this.radios.forEach((r) => r.addEventListener("change", this.render))
    if (this.logoPreview) {
      this.logoObserver = new MutationObserver(this.render)
      this.logoObserver.observe(this.logoPreview, { attributes: true, attributeFilter: ["src", "class"] })
    }
    this.render()
  }

  disconnect() {
    Object.values(this.fields).forEach((f) => f && f.removeEventListener("input", this.render))
    this.radios.forEach((r) => r.removeEventListener("change", this.render))
    if (this.logoObserver) this.logoObserver.disconnect()
  }

  selectedPosition() {
    const checked = this.radios.find((r) => r.checked)
    return checked ? parseInt(checked.value, 10) : 1
  }

  logoSrc() {
    const url = this.fields.logoUrl && this.fields.logoUrl.value.trim()
    if (url) return url
    const img = this.logoPreview
    if (img && !img.classList.contains("hidden")) {
      const src = img.getAttribute("src")
      if (src && /^(data:|https?:)/.test(src)) return src
    }
    return null
  }

  render() {
    const pos = this.selectedPosition()
    this.variants.forEach((v) => {
      const on = parseInt(v.dataset.slot, 10) === pos
      v.style.display = on ? "" : "none"
      if (on) this.fill(v)
    })
    if (this.hasContextTarget) this.contextTarget.textContent = CONTEXT[pos] || ""
  }

  fill(v) {
    const title = (this.fields.title && this.fields.title.value.trim()) || ""
    const subtitle = (this.fields.subtitle && this.fields.subtitle.value.trim()) || ""
    const link = (this.fields.link && this.fields.link.value.trim()) || ""
    const color = (this.fields.color && this.fields.color.value) || "#3b6a00"

    v.querySelectorAll('[data-pf="title"]').forEach((el) => (el.textContent = title || "Your headline here"))
    v.querySelectorAll('[data-pf="subtitle"]').forEach((el) => (el.textContent = subtitle || "Your offer in one line."))
    v.querySelectorAll('[data-pf="cta-link"]').forEach((el) => link && el.setAttribute("href", link))

    const src = this.logoSrc()
    v.querySelectorAll('[data-pf="logo-img"]').forEach((img) => {
      img.style.display = src ? "block" : "none"
      if (src) img.setAttribute("src", src)
    })
    v.querySelectorAll('[data-pf="logo-fallback"]').forEach((fb) => {
      fb.style.display = src ? "none" : "inline-flex"
      if (!src) {
        fb.textContent = (title || "A").charAt(0).toUpperCase()
        fb.style.backgroundColor = color
      }
    })
  }
}
